export default "__VITE_ASSET__Im5fDJaF__"